class BalanceSheet {
	constructor(
		currentCash,
		currentInventory,
		accountReceivables,
		prepaidExpense,
		fixedAssets,
		currentLiabilities,
		longTermLiabilities,
		contributedCapital,
		retainedEarnings,
		profit,
		profitDistribution,
	) {
		this.currentCash = currentCash;
		this.currentInventory = currentInventory;
		this.accountReceivables = accountReceivables;
		this.prepaidExpense = prepaidExpense;
		this.fixedAssets = fixedAssets;
		this.currentLiabilities = currentLiabilities;
		this.longTermLiabilities = longTermLiabilities;
		this.contributedCapital = contributedCapital;
		this.retainedEarnings = retainedEarnings;
		this.profit = profit;
		this.profitDistribution = profitDistribution;
	}

	getTotalAssets() {
		const currentAssets =
			this.currentCash
			+ this.currentInventory
			+ this.prepaidExpense
			+ this.accountReceivables;

		return currentAssets + this.fixedAssets;
	}

	getTotalEquity() {
		return this.contributedCapital
			+ this.retainedEarnings
			+ this.profit
			- this.profitDistribution;
	}

	getTotalLiabilitiesAndEquity() {
		return this.currentLiabilities + this.longTermLiabilities + this.getTotalEquity();
	}

	toPlainObj() {
		return {
			currentCash: this.currentCash,
			currentInventory: this.currentInventory,
			accountReceivables: this.accountReceivables,
			prepaidExpense: this.prepaidExpense,
			fixedAssets: this.fixedAssets,
			totalAssets: this.getTotalAssets(),
			currentLiabilities: this.currentLiabilities,
			longTermLiabilities: this.longTermLiabilities,
			contributedCapital: this.contributedCapital,
			retainedEarnings: this.retainedEarnings,
			profit: this.profit,
			profitDistribution: this.profitDistribution,
			totalEquity: this.getTotalEquity(),
			totalLiabilitiesAndEquity: this.getTotalLiabilitiesAndEquity(),
		};
	}
};

export default function BalanceSheetBuilder() {
	return {
		withCurrentCash: function (currentCash) {
			this.currentCash = currentCash;
			return this;
		},
		withCurrentInventory: function (currentInventory) {
			this.currentInventory = currentInventory;
			return this;
		},
		withPrepaidExpense: function (prepaidExpense) {
			this.prepaidExpense = prepaidExpense;
			return this;
		},
		withAccountReceivables: function (accountReceivables) {
			this.accountReceivables = accountReceivables;
			return this;
		},
		withFixedAssets: function (fixedAssets) {
			this.fixedAssets = fixedAssets;
			return this;
		},
		withCurrentLiabilities: function (currentLiabilities) {
			this.currentLiabilities = currentLiabilities;
			return this;
		},
		withLongTermLiabilities: function (longTermLiabilities) {
			this.longTermLiabilities = longTermLiabilities;
			return this;
		},
		withContributedCapital: function (contributedCapital) {
			this.contributedCapital = contributedCapital;
			return this;
		},
		withRetainedEarnings: function (retainedEarnings) {
			this.retainedEarnings = retainedEarnings;
			return this;
		},
		withProfit: function (profit) {
			this.profit = profit;
			return this;
		},
		withProfitDistribution: function (profitDistribution) {
			this.profitDistribution = profitDistribution;
			return this;
		},
		build: function () {
			return new BalanceSheet(
				this.currentCash,
				this.currentInventory,
				this.accountReceivables,
				this.prepaidExpense,
				this.fixedAssets,
				this.currentLiabilities,
				this.longTermLiabilities,
				this.contributedCapital,
				this.retainedEarnings,
				this.profit,
				this.profitDistribution,
			);
		}
	};
}

export function getNewEmptyBalanceSheetObj() {
	return new BalanceSheetBuilder()
		.withCurrentCash(0)
		.withCurrentInventory(0)
		.withPrepaidExpense(0)
		.withAccountReceivables(0)
		.withFixedAssets(0)
		.withCurrentLiabilities(0)
		.withLongTermLiabilities(0)
		.withContributedCapital(0)
		.withRetainedEarnings(0)
		.withProfit(0)
		.withProfitDistribution(0)
		.build()
		.toPlainObj();
}
